import { render } from "./customManageEdit.vue?vue&type=template&id=4bbc85c7"
import script from "./customManageEdit.vue?vue&type=script&lang=js"
export * from "./customManageEdit.vue?vue&type=script&lang=js"

import "./customManageEdit.vue?vue&type=style&index=0&id=4bbc85c7&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__